/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance } from '../../utils/axiosInstance';

// ----------------------------------------------------------------------

const url = process.env.CORPORATE_INVESTOR_FORM;
const support_url = process.env.RSL_ADMIN_SUPPORT_URL;

const initialState = {
  isLoading: false,
  error: null,
  products: [],
  product: null,
  corporateList: [],
  rentalCarList: [],
  saveBooking: [],
  saveFlights: [],
  saveBuses: [],
  saveActivities: [],
  saveHotels: [],
  saveHolidays: [],
  createBooking: null,
  rentalCarListDetail: undefined,
  bookingCabsRecUpcome: undefined,
  bookingListRecCab: null,
  listBookingSuccessRes: null,
  bookingRes: undefined,
  rslCarSearchFilterRes: undefined,
  cancelTripRes: undefined,
  bookingListRec: [],
  bookingListViewRes: undefined,
  hotelsList: undefined,
  getSupplierFaqListRes: undefined,
  getSupplierCategoryListRes: undefined,
  locationListFromTaxiRes: undefined,
  manageLocationRes: undefined,
  subLocationDetailRes: undefined,
  supplierDocumentUploadRes: undefined,
  corporateFromRec: undefined,
  corporateOtpRec: undefined,
  corporateOtpRecNew: undefined,
  bookingListRecUpcome: []
};

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      // state.corporateFromRec = null
      // state.corporateOtpRec = null
      // state.corporateOtpRecNew = null
      // state.webBookerFromRec = null
      // state.supplierDocumentUploadRes = null
      // state.investorFromRec = null
    },

    // GET CORPORATE
    getRentalCarListSuccess(state, action) {
      state.isLoading = false;
      state.rentalCarList = action.payload;
    },

    // CREATE BOOKING
    createCarBookingSuccess(state, action) {
      state.isLoading = false;
      state.createBooking = action.payload;
    },

    // GET BOOKING
    getBookingListSuccess(state, action) {
      state.isLoading = false;
      state.bookingList = action.payload;
    },
    // GET SAVEBOOKING
    getSaveBookingSuccess(state, action) {
      state.isLoading = false;
      state.saveBooking = action.payload;
    },
    //GET SAVEFLIGHTSBOOKING
    getSaveFlightsSuccess(state, action) {
      state.isLoading = false;
      state.saveBookingFlights = action.payload;
    },

    //GET SAVEHOTELS
    getSaveHotelSuccess(state, action) {
      state.isLoading = false;
      state.saveBookingHotels = action.payload;
    },
    //GET SAVESAFARI
    getSaveSafariSuccess(state, action) {
      state.isLoading = false;
      state.saveBookingSafari = action.payload;
    },
    //GET SAVEACTIVITIES
    getSaveActivitiesSuccess(state, action) {
      state.isLoading = false;
      state.saveBookingActivities = action.payload;
    },

    //GET SAVEHOLIDAYS
    getSaveHolidaysSuccess(state, action) {
      state.isLoading = false;
      state.saveBookingHolidays = action.payload;
    },
    // GET TRIPLIST
    getTripListSuccess(state, action) {
      state.isLoading = false;
      state.tripList = action.payload;
    },
    // Get SignUp
    getSignUpSuccess(state, action) {
      state.isLoading = false;
      state.signUpData = action.payload;
    },
    // Get VerifyPhone
    getVerifyPhoneSuccess(state, action) {
      state.isLoading = false;
      state.verifyPhoneData = action.payload;
    },
    getInvesterFormSubmitSuccess(state, action) {
      state.isLoading = false;
      state.investorFromRec = action.payload;
    },
    getCorporateFormSubmitSuccess(state, action) {
      state.isLoading = false;
      state.corporateFromRec = action.payload;
    },
    getCorporateFormSubmitNewSuccess(state, action) {
      state.isLoading = false;
      state.webBookerFromRec = action.payload;
    },
    getCorporateOtpSubmitSuccess(state, action) {
      state.isLoading = false;
      state.corporateOtpRec = action.payload;
    },
    getCorporateOtpSubmitNewSuccess(state, action) {
      state.isLoading = false;
      state.corporateOtpRecNew = action.payload;
    },
    getSupplierDocumentUploadSuccess(state, action) {
      state.isLoading = false;
      state.supplierDocumentUploadRes = action.payload;
    },
    getSendAppLinkSuccess(state, action) {
      state.isLoading = false;
      state.sendAppRec = action.payload;
    },
    getCancelListSuccess(state, action) {
      state.isLoading = false;
      state.cancelList = action.payload;
    },
    getBusListSuccess(state, action) {
      state.isLoading = false;
      state.busList = action.payload;
    },
    getHotelListSuccess(state, action) {
      state.isLoading = false;
      state.hotelsList = action.payload;
    },
    getBookingAllListSuccess(state, action) {
      state.isLoading = false;
      state.bookingListRec = action.payload;
    },
    bookingUpcomingListSuccess(state, action) {
      state.isLoading = false;
      state.bookingListRecUpcome = action.payload;
    },
    listBookingSuccess(state, action) {
      state.isLoading = false;
      state.listBookingSuccessRes = action.payload;
    },
    guestBookingListSuccess(state, action) {
      state.isLoading = false;
      state.guestBookingListSuccessRes = action.payload;
    },
    bookingCabListSuccess(state, action) {
      state.isLoading = false;
      state.bookingListRecCab = action.payload;
    },
    bookingHistoryListSuccess(state, action) {
      state.isLoading = false;
      state.bookingListRecHistory = action.payload;
    },
    bookingToursListSuccess(state, action) {
      state.isLoading = false;
      state.bookingToursRecHistory = action.payload;
    },
    getAttractionListSuccess(state, action) {
      state.isLoading = false;
      state.attractionListRes = action.payload;
    },
    getTermsListSuccess(state, action) {
      state.isLoading = false;
      state.termsListRes = action.payload;
    },
    getLegacyListSuccess(state, action) {
      state.isLoading = false;
      state.legacyListRes = action.payload;
    },
    getPolicyListSuccess(state, action) {
      state.isLoading = false;
      state.policyListRes = action.payload;
    },
    getPolicyViewSuccess(state, action) {
      state.isLoading = false;
      state.policyViewRes = action.payload;
    },
    getPolicyUpdateSuccess(state, action) {
      state.isLoading = false;
      state.policyUpdateRes = action.payload;
    },
    getAttractionListByIdSuccess(state, action) {
      state.isLoading = false;
      state.attractionListByIdRes = action.payload;
    },
    getBookingListViewSuccess(state, action) {
      state.isLoading = false;
      state.bookingListViewRes = action.payload;
    },
    getTravelInsertSuccess(state, action) {
      state.isLoading = false;
      state.travelCreateRes = action.payload;
    },
    // Get CarList
    getVendorVerifyOtpSuccess(state, action) {
      state.isLoading = false;
      state.vendorOtpVeridy = action.payload;
    }, // Get CarList
    getRentalCarListNewSuccess(state, action) {
      state.isLoading = false;
      state.rentalCarListNew = action.payload;
    },
    // Get CarList
    getRentalCarDetailsNewSuccess(state, action) {
      state.isLoading = false;
      state.rentalCarListDetail = action.payload;
    },
    // Get CarList
    getRentalCarBookingNewSuccess(state, action) {
      state.isLoading = false;
      state.bookingRes = action.payload;
    },
    getSearchCarSuccess(state, action) {
      state.isLoading = false;
      state.carSearchRes = action.payload;
    },
    getSearchCarFilterSuccess(state, action) {
      state.isLoading = false;
      state.carSearchFilterRes = action.payload;
    },
    getSearchRslCarFilterSuccess(state, action) {
      state.isLoading = false;
      state.rslCarSearchFilterRes = action.payload;
    },
    getTaxiBookingListSuccess(state, action) {
      state.isLoading = false;
      state.taxilistRes = action.payload;
    },
    getCancelTripSuccess(state, action) {
      state.isLoading = false;
      state.cancelTripRes = action.payload;
    },
    getServiceListSuccess(state, action) {
      state.isLoading = false;
      state.serviceListRes = action.payload;
    },
    getBlogListSuccess(state, action) {
      state.isLoading = false;
      state.blogListRes = action.payload;
    },
    getBlogViewSuccess(state, action) {
      state.isLoading = false;
      state.viewListRes = action.payload;
    },
    getRatingSuccess(state, action) {
      state.isLoading = false;
      state.ratingRes = action.payload;
    },
    getContactInfoSuccess(state, action) {
      state.isLoading = false;
      state.contactInfoRes = action.payload;
    },
    getTermsAndConditionListSuccess(state, action) {
      state.isLoading = false;
      state.getTermsAndConditionList = action.payload;
    },
    gettboCountryListSuccessRes(state, action) {
      state.isLoading = false;
      state.gettboCountryListRes = action.payload;
    },
    getSupplierFaqSuccessRes(state, action) {
      state.isLoading = false;
      state.getSupplierFaqListRes = action.payload;
    },
    getSupplierCategorySuccessRes(state, action) {
      state.isLoading = false;
      state.getSupplierCategoryListRes = action.payload;
    },
    locationListFromTaxiSuccessRes(state, action) {
      state.isLoading = false;
      state.locationListFromTaxiRes = action.payload;
    },
    fetchManageLocationSuccessRes(state, action) {
      state.isLoading = false;
      state.manageLocationRes = action.payload;
    },
    subLocationDetailSuccessRes(state, action) {
      state.isLoading = false;
      state.subLocationDetailRes = action.payload;
    },
    getModelListSuccessRes(state, action) {
      state.isLoading = false;
      state.modelListRes = action.payload;
    },
    resetCorporateState(state) {
      state.corporateFromRec = null;
      state.corporateOtpRec = null;
    },
    clearInvestorFormState(state) {
      state.investorFromRec = null;
      state.isLoading = false;
    },
    getSubscribePersonalChauffeurSuccess(state, action) {
      state.isLoading = false;
      state.subscribePersonalChauffeurRes = action.payload;
    },
    clearSubscribePersonalChaufferFormState(state) {
      state.subscribePersonalChauffeurRes = null;
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export function getRentalCarList(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/api/listCar`,
        filterParam
      );
      dispatch(
        slice.actions.getRentalCarListSuccess(response.data.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBookingList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/api/listBooking`,
        {
          customerInfo: {
            _id: '649d5630332b585165807967',
          },
        }
      );
      dispatch(slice.actions.getBookingListSuccess(response.data.responseData));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTripList(dataOneParams) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/rslTourism/tripList`,
        dataOneParams
        //   {
        //     limit: 20,
        //     countryCode: "+91",
        //     mobile: "7010339013",
        //     user_id: "649d5630332b585165807967",
        //     start: 1
        // }
      );
      dispatch(slice.actions.getTripListSuccess([response.data]));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createCarBooking(bookingParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/api/listCar`,
        bookingParam
        //     {
        //   "pickupLocation": "Coimbatore",
        //   "pickupDate": "2023-06-25",
        //   "dropOffDate": "2023-06-26",
        //   "carmodel": {
        //     "name": "VOLKSWAGON TERAMONT",
        //     "image": "volkswagon_teramont.png",
        //     "seat": 4,
        //     "door": 4,
        //     "price": 50,
        //     "type": 2
        //   },
        //   "customerInfo": {
        //     "_id": "64954dcd25970433472e65c9",
        //     "countryCode": "+91",
        //     "mobile": "9626751620",
        //     "name": "Nihitha",
        //     "email": "nihi08@gmail.com",
        //     "role": 1
        //   }
        //  }
      );
      dispatch(
        slice.actions.createCarBookingSuccess(response.data.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

//SAVEBOOKING
export function getSaveBooking(saveBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.RSL_BACKEND_URL}/trip/savebooking`,
        saveBooking
      );
      dispatch(slice.actions.getSaveBookingSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

//SAVEFLIGHTS

export function saveFlightsBooking(saveBookingFlights) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/flight`,
        saveBookingFlights
      );
      dispatch(slice.actions.getSaveFlightsSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

//SAVEHOTELSBOOKINGS

export function saveHotelBooking(saveBookingHotels) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/hotel`,
        saveBookingHotels
      );
      dispatch(slice.actions.getSaveHotelSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

//SAVESafariBOOKING

export function saveSafariBooking(saveBookingSafari) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/safari`,
        saveBookingSafari
      );
      dispatch(slice.actions.getSaveSafariSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

//SAVEACTIVITIES

export function saveActivitiesBooking(saveBookingActivities) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/activities`,
        saveBookingActivities
      );
      dispatch(slice.actions.getSaveActivitiesSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

//SAVEHOLIDAYSBOOKING

export function saveHolidaysBooking(saveBookingHolidays) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/holidays`,
        saveBookingHolidays
      );
      dispatch(slice.actions.getSaveHolidaysSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

// Sign Up
export function signUp(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/user/signup`,
        obj
      );
      dispatch(slice.actions.getSignUpSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

// Verify Phone
export function verifyPhone(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/user/verifyPhone`,
        obj
      );
      dispatch(slice.actions.getVerifyPhoneSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

// investor form

export function investerFormSubmit(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/driverInvestorRegistration`,
        obj
      );
      // const response = await axiosInstance.post(
      //   'https://royalback.royalsmartlimousine.com/api/driverInvestorRegistration',
      //   obj
      // );
      // const response = await axiosInstance.post(
      //   'http://15.184.30.109:4004/rslTourism/driverInvestorRegistration',
      //   obj
      // );
      dispatch(slice.actions.getInvesterFormSubmitSuccess(response.data));

      // Clear state after 3 seconds
      setTimeout(() => {
        dispatch(slice.actions.clearInvestorFormState());
      }, 3000);
    } catch (error) {
      dispatch(slice.actions.getInvesterFormSubmitSuccess(error?.response?.data || error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

// corporate form

export function corporateFormSubmit(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/updateCorporateUser`,
        obj
      );

      dispatch(slice.actions.getCorporateFormSubmitSuccess(response.data));

      // Clear state after 3 seconds
      setTimeout(() => {
        dispatch(slice.actions.resetCorporateState());
      }, 3000);
    } catch (error) {
      dispatch(slice.actions.getCorporateFormSubmitSuccess(error?.response?.data || error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function corporateFormSubmitNew(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${url}/corporateRegistration`,
        obj
      );

      dispatch(slice.actions.getCorporateFormSubmitNewSuccess(response.data));

      // Clear state after 3 seconds
      setTimeout(() => {
        dispatch(slice.actions.resetCorporateState());
      }, 3000);
    } catch (error) {
      dispatch(slice.actions.getCorporateFormSubmitNewSuccess(error?.response?.data || error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function corporateFormSubmitNewClear() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());


    dispatch(slice.actions.getCorporateFormSubmitNewSuccess(null));


  };
}

//personal chaufer form

export function subscribePersonalChauffeur(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.RSL_BACKEND_URL}/trip/subscribePersonalChauffeur`,
        obj
      );

      dispatch(slice.actions.getSubscribePersonalChauffeurSuccess(response.data));

      // Clear state after 3 seconds
      setTimeout(() => {
        dispatch(slice.actions.clearSubscribePersonalChaufferFormState());
      }, 3000);
    } catch (error) {
      dispatch(slice.actions.getSubscribePersonalChauffeurSuccess(error?.response?.data || error));
      dispatch(slice.actions.hasError(error));
    }
  };
}


// corporate otp verify

export function corporateOtpSubmit(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/verifyOtp`, obj);

      dispatch(slice.actions.getCorporateOtpSubmitSuccess(response.data));

      // Clear state after 3 seconds
      setTimeout(() => {
        dispatch(slice.actions.resetCorporateState());
      }, 3000);
    } catch (error) {
      dispatch(slice.actions.getCorporateOtpSubmitSuccess(error?.response?.data || error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function corporateOtpSubmitNew(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`${url}/corporateVerifyOtp`, obj);

      dispatch(slice.actions.getCorporateOtpSubmitNewSuccess(response.data));

      // Clear state after 3 seconds
      setTimeout(() => {
        dispatch(slice.actions.resetCorporateState());
      }, 3000);
    } catch (error) {
      dispatch(slice.actions.getCorporateOtpSubmitNewSuccess(error?.response?.data || error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function supplierDocumentUpload(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      // const response = await axiosInstance.post(`${url}/uploadImageToTempFolder`, obj);
      const response = await axiosInstance.post(`${support_url}/document/uploadTempSingle`, obj,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      dispatch(slice.actions.getSupplierDocumentUploadSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.getSupplierDocumentUploadSuccess(error?.response?.data || error));
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function sendAppLink(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/user/sendAppLink`,
        obj
      );

      dispatch(slice.actions.getSendAppLinkSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCancelList(cancelData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/rslTourism/getDriverReplyBidding`,
        cancelData
      );

      dispatch(slice.actions.getCancelListSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBusList(cancelData) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/bus/list`,
        cancelData
      );

      dispatch(slice.actions.getBusListSuccess(response.data.responseData));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getHotelList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const obj = {
      CityCode: '130443',
      IsDetailedResponse: 'true',
    };
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/hotel/list`,
        obj
      );

      dispatch(slice.actions.getHotelListSuccess(response.data?.Hotels));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function bookingAllList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/listBookingUser`,
        obj
      );

      dispatch(
        slice.actions.getBookingAllListSuccess(response.data.bookingList)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function bookingUpcomingList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/guestBookingList`,
        obj
      );

      dispatch(
        slice.actions.bookingUpcomingListSuccess(response.data.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function listBooking(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/listBooking`,
        obj
      );

      dispatch(
        slice.actions.listBookingSuccess(response.data.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function guestBookingList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/guestBookingList`,
        obj
      );

      dispatch(
        slice.actions.guestBookingListSuccess(response.data.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function bookingCabsList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const rslkeyId = sessionStorage.getItem('rslkeyId');
    const tempObj = {
      ...obj,
      passengerId: rslkeyId ?? undefined
    }
    try {
      const response = await axiosInstance.post(
        `${process.env.RSL_BACKEND_URL}/trip/tripList`,
        tempObj
      );

      dispatch(
        slice.actions.bookingCabListSuccess(response.data)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function bookingHistoryList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/listBookingHistory`,
        obj
      );

      dispatch(
        slice.actions.bookingHistoryListSuccess(response.data.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function bookingToursList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/listBookingTours`,
        obj
      );

      dispatch(
        slice.actions.bookingToursListSuccess(response.data.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function attractionList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/attraction/list`
      );
      dispatch(
        slice.actions.getAttractionListSuccess(response.data.attractionList)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
// Privacy policy

export function policyList(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        // `${process.env.BACKEND_URL}/attraction/list`
        `${process.env.BACKEND_URL}/blog/policiesList`
      );
      dispatch(slice.actions.getPolicyListSuccess(response.data.responseData));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
// policy create
export function policyCreate(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const obj = {
      policies: value.policies,
    };
    try {
      const response = await axiosInstance.post(
        // `${process.env.BACKEND_URL}/attraction/list`
        `${process.env.BACKEND_URL}/blog/policies`,
        obj
      );
      dispatch(slice.actions.getPolicyCreateSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
// policy view
export function policyView(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const obj = {
      id: id,
    };
    try {
      const response = await axiosInstance.post(
        // `${process.env.BACKEND_URL}/attraction/list`
        `${process.env.BACKEND_URL}/blog/policiesGetById`,
        obj
      );
      dispatch(slice.actions.getPolicyViewSuccess(response.data.responseData));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
// policy update
export function policyUpdate(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const obj = {
      id: value.id,
    };
    try {
      const response = await axiosInstance.get(
        // `${process.env.BACKEND_URL}/attraction/list`
        `${process.env.BACKEND_URL}/blog/updatePolicies`,
        obj
      );
      dispatch(slice.actions.getPolicyUpdateSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
// terms list

export function termsList(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        // `${process.env.BACKEND_URL}/attraction/list`
        `${process.env.BACKEND_URL}/blog/termsList`
      );
      dispatch(slice.actions.getTermsListSuccess(response.data.responseData));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function legacyList(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        // `${process.env.BACKEND_URL}/attraction/list`
        `${process.env.BACKEND_URL}/blog/legacyList`
      );
      dispatch(slice.actions.getLegacyListSuccess(response.data.responseData));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function attractionListById(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const obj = {
      id: id,
    };
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/attraction/getById`,
        obj
      );
      dispatch(
        slice.actions.getAttractionListByIdSuccess(
          response.data.attractionDetails
        )
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function bookingListView(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/bookingDetails`,
        obj
      );
      dispatch(
        slice.actions.getBookingListViewSuccess(response.data.bookingDetails)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function travelInsert(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/user/vendorCreate`,
        obj
      );
      dispatch(slice.actions.getTravelInsertSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function vendorVerifyOtp(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/user/vendorVerifyOtp`,
        obj
      );
      dispatch(slice.actions.getVendorVerifyOtpSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRentalCarListNew(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/car/listCarPackages`,
        filterParam
      );

      dispatch(
        slice.actions.getRentalCarListNewSuccess(response.data.responseData)
      );
    } catch (error) {
      slice.actions.getRentalCarListNewSuccess(error);

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRentalCarDetails(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/car/carDetails`,
        filterParam
      );

      dispatch(
        slice.actions.getRentalCarDetailsNewSuccess(
          response.data.carPackageDetails
        )
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRentalCarBooking(filterParam) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/carBooking `,
        filterParam
      );

      dispatch(slice.actions.getRentalCarBookingNewSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchCar(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/car/searchCar`,
        obj
      );
      dispatch(slice.actions.getSearchCarSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchCarFilter(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.get(
        `${process.env.BACKEND_URL}/car/filterList`,
        obj
      );
      dispatch(
        slice.actions.getSearchCarFilterSuccess(response.data?.responseData)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

// rsl car list api
export function searchRslCarFilter(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/api/listCar`,
        obj
      );
      dispatch(
        slice.actions.getSearchRslCarFilterSuccess(response.data)
      );
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function taxiBookingList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.RSL_BACKEND_URL}/trip/tripList`,
        obj
      );
      dispatch(slice.actions.getTaxiBookingListSuccess(response.data?.detail));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}
export function cancelTrip(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/cancelTrip`,
        obj
      );
      dispatch(slice.actions.getCancelTripSuccess(response.data));
    } catch (error) {

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getServiceList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.get(
        `${process.env.BACKEND_URL}/common/serviceList`
      );

      if (response.data?.responseData !== undefined) {
        dispatch(
          slice.actions.getServiceListSuccess(response.data?.responseData)
        );
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBlogList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/blog/blogList`
      );

      if (response.data?.blogs !== undefined) {
        dispatch(slice.actions.getBlogListSuccess(response.data?.blogs));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getBlogView(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    const obj = {
      id,
    };
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/blog/blogGetById`,
        obj
      );

      if (response.data !== undefined) {
        dispatch(slice.actions.getBlogViewSuccess(response.data?.blog));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRating(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/getRating`,
        obj
      );

      if (response.data !== undefined) {
        dispatch(slice.actions.getRatingSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getContactInfo(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/user/contactUs`,
        obj
      );

      if (response.data !== undefined) {
        dispatch(slice.actions.getContactInfoSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function clearGetContactInfo() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.getContactInfoSuccess(null));
  };
}

export function termsAndConditionList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/common/getTermsAndCondition`,
        obj
      );
      dispatch(slice.actions.getTermsAndConditionListSuccess(response.data?.responseData));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function gettboCountryList(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.get(
        `${process.env.BACKEND_URL}/common/tboCountryList`,
        obj
      );
      if (response.data !== undefined) {
        dispatch(slice.actions.gettboCountryListSuccessRes(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSupplierFaq(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.get(
        `${process.env.BACKEND_URL}/supplier/faqList`,
        obj
      );
      if (response.data !== undefined) {
        dispatch(slice.actions.getSupplierFaqSuccessRes(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getSupplierCategory(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.get(
        `${process.env.BACKEND_URL}/supplier/getSupplierCategory`,
        obj
      );
      if (response.data !== undefined) {
        dispatch(slice.actions.getSupplierCategorySuccessRes(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function locationListFromTaxi(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.get(
        `${process.env.BACKEND_URL}/supplier/getMainLocations`,
        obj
      );
      if (response.data !== undefined) {
        dispatch(slice.actions.locationListFromTaxiSuccessRes(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function fetchManageLocation(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/supplier/getSubLocations`,
        obj
      );
      if (response.data !== undefined) {
        dispatch(slice.actions.fetchManageLocationSuccessRes(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function subLocationDetail(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/supplier/getSubLocationDetail`,
        obj
      );
      if (response.data !== undefined) {
        dispatch(slice.actions.subLocationDetailSuccessRes(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getModelList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.get(
        `${process.env.RSL_BACKEND_URL}/trip/modelList`
      );
      if (response.data !== undefined) {
        dispatch(slice.actions.getModelListSuccessRes(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}